import "regenerator-runtime/runtime";
import "lib/polyfills";
import "styles/tailwind.css";
import "lib/monkeyPatching";

// MetaMask's inpage.js can throw an unhandled rejection during its own
// background-page handshake if the extension service-worker isn't ready yet.
// This is internal to MetaMask and has no effect on functionality — suppress it
// so it doesn't pollute the console.
window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
  const msg: string = event.reason?.message ?? event.reason ?? "";
  if (
    msg.includes("MetaMask") ||
    msg.includes("extension not found") ||
    msg.includes("Extension not found")
  ) {
    event.preventDefault();
  }
});

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import WalletProvider from "lib/wallets/WalletProvider";
import App from "./App/App";
import reportWebVitals from "./reportWebVitals";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Router>
      <WalletProvider>
        <App />
      </WalletProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export { formatTokenAmount, formatTokenAmountWithUsd, formatUsd } from "./lib/numbers";
